const colors = {
    primary: '#092e15',
    secondary: '#d15c16',
    btnActiveText: '#d85912',
    sidebarActive: '#1d9b3f',
    sidebarHover: 'rgba(255, 255, 255, 0.12)',
    sidebarBorder: 'rgba(255, 255, 255, 0.18)',
}

export default colors
